import React, { useState } from 'react'
import styled from 'styled-components'
import SVG from 'react-inlinesvg'

const Container = styled.div`
  position: relative;

  input {
    height: 50px;
    padding: 7px 0;
    padding-left: 18px;
    padding-right: 44px;
    margin-bottom: 24px;
    border: 1px solid var(--panel-border);
    border-radius: 4px;
    background: white;
  }

  svg {
    position: absolute;
    top: 14px;
    right: 12px;
  }
`

export default function SearchQuery(props) {
  const { initialValue, updateValue } = props

  const [value, setValue] = useState(initialValue)

  return (
    <Container>
      <input
        type="text"
        placeholder="Search"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onBlur={() => updateValue(value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.target.blur()
          }
        }}
      />
      <button className="a" onClick={() => updateValue(value)}>
        <SVG src="/images/icons/search.svg" />
      </button>
    </Container>
  )
}
